// GLAS Attribution — UTM + fbclid capture
// Captures first-touch UTM and fbclid from URL, persists to localStorage,
// writes to Shopify cart attributes via /cart/update.js
// Source pattern: Shopify AJAX Cart API + community.latenode.com

(function glassAttribution() {
  'use strict';

  var UTM_KEYS = ['utm_source', 'utm_medium', 'utm_campaign', 'utm_content', 'utm_term'];
  var STORAGE_KEY = 'glas_attr_v1';

  function getUrlParams() {
    var params = new URLSearchParams(window.location.search);
    var data = {};
    UTM_KEYS.forEach(function(k) {
      var v = params.get(k);
      if (v) data[k] = v;
    });
    var fbclid = params.get('fbclid');
    if (fbclid) data['fbclid'] = fbclid;
    return data;
  }

  function setFbcCookie(fbclid) {
    // Only set if _fbc cookie not already present (Meta Pixel may have set it)
    if (!document.cookie.match(/_fbc=/)) {
      var fbc = 'fb.1.' + Date.now() + '.' + fbclid;
      document.cookie = '_fbc=' + fbc + '; path=/; max-age=7776000; SameSite=Lax';
    }
  }

  function writeToCart(attributes) {
    // Silent fail — attribution is non-critical, must not break checkout
    try {
      fetch(window.Shopify.routes.root + 'cart/update.js', {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        credentials: 'same-origin',
        body: JSON.stringify({ attributes: attributes })
      }).catch(function() {});
    } catch(e) {}
  }

  // Step 1: Capture incoming URL params
  var incoming = getUrlParams();

  if (Object.keys(incoming).length > 0) {
    // First-touch only: do not overwrite if attribution already stored
    if (!localStorage.getItem(STORAGE_KEY)) {
      localStorage.setItem(STORAGE_KEY, JSON.stringify(incoming));
    }
    // Always set _fbc cookie on fresh fbclid (even if UTMs already stored)
    if (incoming.fbclid) {
      setFbcCookie(incoming.fbclid);
    }
  }

  // Step 2: Write stored attribution to cart (always, on every page)
  // /cart/update.js is idempotent — repeated writes of same values are safe
  var stored = null;
  try {
    stored = JSON.parse(localStorage.getItem(STORAGE_KEY));
  } catch(e) {}

  if (stored && typeof stored === 'object') {
    writeToCart(stored);
  }

})();
